export default {
    setPosts(state, payload) {
        state.posts = payload.items;
    }
}